// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Components
import Modal from '../Modal/Modal';
import OMGenericSelect from '../OMComponents/OMGenericSelect/OMGenericSelect';

class DeletePropertyModal extends Component {
  state = {
    val: '',
    hasError: false,
    reason: ''
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    const { val, reason } = this.state;
    if (!this.state.val || (val === 'other' && !reason)) {
      return this.setState({ hasError: true });
    }

    return this.props.handleSubmit({ option: val, answer: reason });
  };

  render() {
    const {
      isOpen,
      hideDeleteModal,
      deleteOptions,
      headerText,
      selectPlaceholder,
      inputPlaceholder,
      errorText,
      deleteButtonText,
      cancelButtonText
    } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        className="deletePropertyModal"
        isOpen={isOpen}
        onRequestClose={hideDeleteModal}
        isCloseButtonInvisible
      >
        <form
          name="deletePropertyForm"
          onSubmit={this.handleSubmit}
          className={this.state.val === 'other' ? 'extended' : null}
        >
          <p>{ headerText }</p>
          <OMGenericSelect
            options={deleteOptions}
            value={this.state.val}
            onChange={(val) => { this.setState({ val, hasError: false, reason: '' }); }}
            placeholder={selectPlaceholder.toString()}
          />
          { this.state.val === 'other' ? (
            <input
              type="text"
              value={this.state.reason}
              onChange={evt => this.setState({ reason: evt.target.value, hasError: false })}
              placeholder={inputPlaceholder}
            />
          ) : null }

          <p className="errorMessage">{ this.state.hasError ? errorText : '' }</p>

          <div>
            <button className="btn btn-primary" type="submit">{ deleteButtonText }</button>
            <button className="btn btn-default" onClick={hideDeleteModal}>{ cancelButtonText }</button>
          </div>
        </form>
      </Modal>
    );
  }
}

DeletePropertyModal.propTypes = {
  isOpen: PropTypes.bool,
  hideDeleteModal: PropTypes.func,
  deleteOptions: PropTypes.array,
  headerText: PropTypes.func,
  selectPlaceholder: PropTypes.func,
  inputPlaceholder: PropTypes.func,
  errorText: PropTypes.func,
  handleSubmit: PropTypes.func,
  deleteButtonText: PropTypes.func,
  cancelButtonText: PropTypes.func
};

export default DeletePropertyModal;
